
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Drawer from 'vux/src/components/drawer/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { mapState, mapActions } from 'vuex'


import nativeApi from '@/common/tool/sdk2/nativeApi'
import systemHook from '@/config/systemHook'
import { setTimeout } from 'timers';
export default {
name: 'app',
directives: {
TransferDom
},
data () {
return {

}
},
created () {
let _this = this

if (this.$route.query.isNative || sessionStorage.isNative == true) {
this.$store.commit('SET_NATIVE_FLAG', true)

nativeApi.createListen(_this)
setTimeout(()=>{
nativeApi.nativeFN.H5Ready()
},50)
} else {
this.$store.commit('SET_NATIVE_FLAG', false)
if(systemHook&&systemHook.appInitManageUserInfoH5){
systemHook.appInitManageUserInfoH5(this)
}else{
nativeApi.H5Init(_this)
}
}
},
computed: {
...mapState({
route: state => state.route,
path: state => state.route.path,
deviceready: state => state.app.deviceready,

isLoading: state => state.vux.isLoading,
direction: state => state.vux.direction
}),
headerTransition () {
if (!this.direction) return ''
return this.direction === 'forward' ? 'vux-header-fade-in-right' : 'vux-header-fade-in-left'
},
title () {
if (this.route.path === '/') return 'Home'
if (this.route.path === '/project/donate') return 'Donate'
if (this.route.path === '/demo') return 'Demo list'
return this.componentName ? `Demo/${this.componentName}` : 'Demo/~~'
},
leftOptions () {
return {
showBack: this.route.path !== '/'
}
},
viewTransition () {

if (!this.direction) return ''
return 'vux-pop-' + (this.direction === 'forward' ? 'in' : 'out')
}
},
components: {
Radio,
Group,
Cell,
Badge,
Drawer,
ButtonTab,
ButtonTabItem,
ViewBox,
XHeader,
Tabbar,
TabbarItem,
Loading,
Actionsheet
}
}



// WEBPACK FOOTER //
// ./src/App.vue